import {Injectable} from "@angular/core";

@Injectable()
export class LocalStorageService implements NPS.Common.ILocalStorageService {

    storage: Storage;

    constructor() {
        this.storage = localStorage;
    }

    get<T>(key: string): T {
        var serialized: string = this.storage.getItem(key);
        return serialized ? <T>JSON.parse(serialized) : undefined;
    }

    set<T>(key: string, data: T) {
        var serialized: string = JSON.stringify(data);
        this.storage.setItem(key, serialized);
    }

    remove(key: string) {
        this.storage.removeItem(key);
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Storage/LocalStorageService.ts